import DropPosition from './DropPosition'
import { getKey, throwError } from '@/util'

export default {
  components: {
    DropPosition
  },
  props: {
    endpoint: { type: String, required: true },
    group: { type: String, required: true },
    config: { type: Object, required: false },
    dropMode: { type: String, required: false }
  },
  data () {
    return {
      showText: '',
      dragOverPosition: false,
      selected: false,
      properties: {
        css: '',
        style: ''
      },
      advancedProperties: {},
      methods: {},
      events: {},
      hooks: {},
      children: []
    }
  },
  created () {
    if (this.config) {
      this.changeProperties()
      if (this.config.children && this.config.children.length) {
        this.setChildren(this.config.children)
      }
    }
  },
  beforeDestroy () {
    this.$emit('beforeDestroy')
  },
  methods: {
    getConfigName () {
      return (this.config ? this.config.name : null) || 'root'
    },
    getShowText () {
      let showText = this.config.text
      if (this.showText) {
        showText += ` - ${this.showText}`
      }
      return showText
    },
    changeProperties () {
      let fields = ['properties', 'advancedProperties', 'methods', 'events', 'hooks']
      for (let field of fields) {
        if (!this.hasOwnProperty(field)) {
          continue
        }

        let properties1 = this[field]
        let properties = this.config[field] || []
        for (let property of properties) {
          if (property.value === undefined) {
            continue
          }

          if (properties1.hasOwnProperty(property.name)) {
            properties1[property.name] = property.value
          }

          if (property.asShowText === true) {
            this.showText = property.value
          }
        }
      }
    },
    changeProperty(property, field) {
      if (!this.hasOwnProperty(field)) {
        return
      }

      let properties = this[field]
      if (properties.hasOwnProperty(property.name)) {
        properties[property.name] = property.value
      }
      if (property.asShowText === true) {
        this.showText = property.value
      }
    },
    getChildren () {
      return this.children
    },
    setChildren (children) {
      this.children = children || []
    },
    addChild (config, index) {
      let children = this.getChildren()
      if (index === undefined) {
        children.push(config)
      } else {
        if (index < 0) {
          index = 0
        }
        if (index >= children.length) {
          children.push(config)
        } else {
          children.splice(index, 0, config)
        }
      }
    },
    triggerRemove () {
      this.$emit('remove', this)
    },
    clone () {
      let config = JSON.parse(JSON.stringify(this.config))
      resetKey(config)
      this.getParentComponent().addChild(config)

      function resetKey (config) {
        let key = 'cmp_id_' + getKey()
        let properties = config.properties || []
        for (let property of properties) {
          if (property.name === 'id') {
            property.value = key
            break
          }
        }
        config.key = key

        let children = config.children || []
        for (let child of children) {
          resetKey(child)
        }
      }
    },
    removeChild (component) {
      let children = this.getChildren()
      for (let i = 0; i < children.length; i++) {
        if (children[i].key === component.config.key) {
          return children.splice(i, 1)[0]
        }
      }
    },
    getChildComponents () {
      let result = []
      let children = this.getChildren()
      let childComponents = [].concat(this.$refs.childComponents || [])
      for (let child of children) {
        for (let childComponent of childComponents) {
          if (child.key === childComponent.config.key) {
            result.push(childComponent)
            break
          }
        }
      }
      return result
    },
    getParentComponent () {
      if (this.$options._componentTag === 'root-component') {
        return null
      }

      function find (parentComponent) {
        if (parentComponent.getParentComponent) {
          return parentComponent
        }
        return find(parentComponent.$parent)
      }

      return find(this.$parent)
    },
    isDescendant (component) {
      if (this.$options._componentTag === 'root-component') {
        return false
      }
      let parentComponent = this.getParentComponent()
      if (parentComponent === component) {
        return true
      }
      return parentComponent.isDescendant(component)
    },
    changeDragOver(position) {
      if (position === false) {
        this.dragOverPosition = false
      } else  {
        this.dragOverPosition = position || 'in'
      }
    },
    changeSelected(selected) {
      this.selected = selected
    },
    getConfig (getValueType, idMap) {
      let config = this.config
      let result = { name: config.name }

      if (config.extra) {
        result.extra = config.extra
      }

      if (getValueType) {
        for (let property of config.properties) {
          if (property.name === 'value') {
            result.valueType = property.type || 'string'
            break
          }
        }
      }

      let properties = this.getProperties(config.properties, true) || []
      for (let property of properties) {
        if (property.name === 'id') {
          let temp = idMap[property.value]
          if (temp) {
            throwError(`[${config.text} - ${config.name}] 与 [${temp.text} - ${temp.name}]的ID相同: ${property.value}`)
          }
          idMap[property.value] = config
          break
        }
      }
      if (properties.length) {
        result.properties = properties
      }
      let advancedProperties = this.getProperties(config.advancedProperties)
      if (advancedProperties.length) {
        result.advancedProperties = advancedProperties
      }
      let methods = this.getProperties(config.methods)
      if (methods.length) {
        result.methods = methods
      }
      let events = this.getProperties(config.events)
      if (events.length) {
        result.events = events
      }
      let hooks = this.getProperties(config.hooks)
      if (hooks.length) {
        result.hooks = hooks
      }

      let children = []
      let childComponents = this.getChildComponents()
      for (let childComponent of childComponents) {
        children.push(childComponent.getConfig(getValueType, idMap))
      }
      if (children.length) {
        result.children = children
      }

      return result
    },
    getProperties (properties, checkFormControlName) {
      properties = properties || []

      let isFormControl
      if (checkFormControlName && this.group === 'index-form') {
        if (this.config.name === 'FormControl') {
          isFormControl = true
        } else {
          let parents = this.config.parents
          for (let parent of parents) {
            if (parent === 'FormControl') {
              isFormControl = true
              break
            }
          }
        }
      }

      let result = []
      let formControlName
      for (let property of properties) {
        let value = property.value
        if (value === undefined || value === '') {
          if (property.required) {
            let msg = `${this.config.text}的属性[${property.text}]为必填项`
            this.$message({ message: msg, duration: 5000, type: 'warning' })
            throw msg
          }
          continue
        }

        if (property.regExp && !(new RegExp(property.regExp).test(value))) {
          let msg = `${this.config.text}的属性[${property.text}]未能通过验证：${property.regMsg}`
          this.$message({ message: msg, duration: 5000, type: 'warning' })
          throw msg
        }

        result.push({
          name: property.name,
          value: property.value
        })

        if (isFormControl && property.name === 'name') {
          formControlName = value
        }
      }

      if (isFormControl) {
        if (!formControlName) {
          let msg = `[${this.config.text}]的表单元素名称为必填项`
          this.$message({ message: msg, duration: 5000, type: 'warning' })
          throw msg
        }
        if (!(/^[a-zA-Z][a-zA-Z0-9_]*$/.test(formControlName))) {
          let msg = `错误的表单元素名: ${formControlName}；只能包含英文字母，数字和下划线，且只能以英文字母开头`
          this.$message({ message: msg, duration: 5000, type: 'warning' })
          throw msg
        }
      }

      return result
    },
    getClass () {
      let clazz = 'pcd-component'
      if (this.config.inline) {
        clazz += ' pcd-component-inline'
      }
      clazz += ` pcd-component-${this.getConfigName()}`
      if (this.dragOverPosition) {
        clazz += ` pcd-component-dragover-${this.dragOverPosition}`
      }
      if (this.selected) {
        clazz += ' pcd-component-selected'
      }
      return clazz
    },
    getStyle () {
      let style = ''
      if (this.properties.style) {
        if (this.properties.style.endsWith(';')) {
          style += `${this.properties.style}`
        } else {
          style += `${this.properties.style};`
        }
      }
      return style
    }
  }
}